import { render, staticRenderFns } from "./BillingDetailsCard.vue?vue&type=template&id=61a31e5e&scoped=true"
import script from "./BillingDetailsCard.vue?vue&type=script&lang=ts"
export * from "./BillingDetailsCard.vue?vue&type=script&lang=ts"
import style0 from "./BillingDetailsCard.vue?vue&type=style&index=0&id=61a31e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a31e5e",
  null
  
)

export default component.exports